import "./Kontakt.module.css";
import Header from "@/reusable_sections/Header";
import HeroProjects from "./sections/HeroProjects";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function KontaktPage() {
  return <div>
      <Header />
      <HeroProjects />
      <GetInTouch />
      <Footer />
    </div>;
}